<script lang="ts">
    import {router} from 'tinro';

    import List, {Item, Graphic, Separator, Text, PrimaryText, SecondaryText} from '@smui/list'
    import Textfield from '@smui/textfield'
    import Icon from '@smui/textfield/icon'

    import RoleEditor from './RoleEditor.svelte'

    import type {ReadyList, Role} from './jmdb'
    import {deep_copy, newId, role_list } from "./jmdb"
    
    export let role_id: string | undefined = undefined

    let newGroupSelected = false
    $: newGroupSelected = (role_id == newId.toString())

    let filterText = ''
    let selectedRights: Role | undefined
    let role_list_sorted: ReadyList<Role>

    role_list.fetch()
    $: role_list_sorted = {ready: $role_list.ready, data: $role_list.data.map(v=>v).sort((a, b) => a.name.localeCompare(b.name))}     


    let emptyRight: Role = {id: newId, name: '', rights: [], specialRights: { streamers: {}, streamerGroups: {} }}
    $: selectedRights = newGroupSelected ? emptyRight : (role_list_sorted.data.find((v) => v.id == Number(role_id)) || undefined)

    
</script>


<div class="row">
    <div class="col-md-3">
        <div style="display: flex; flex-wrap: nowrap;">
            <Textfield withLeadingIcon label="Find" bind:value={filterText} >
                <Icon class="material-icons">search</Icon>
            </Textfield>
        </div>

    </div>
</div>
<div class="row">
    <div class="col-md-3 user-list">
        {#if !role_list_sorted.ready}
            Loading...
        {:else}
            <List singleSelection>
                {#each role_list_sorted.data as actor}
                {#if (!filterText || actor.name.toLowerCase().indexOf(filterText.toLowerCase()) != -1)}
                <Item selected={actor.id == Number(role_id)}>
                    <a class="divLink" href="/mgr/roles/{actor.id}">&nbsp;</a>
                    <Text>{actor.name}</Text>
                </Item>
                <Separator />
                {/if}
                {/each}
            </List>
            <List singleSelection>
                <Item selected={newGroupSelected}>
                    <a class="divLink" href="/mgr/roles/{newId}">&nbsp;</a>
                    <Graphic class="material-icons">add</Graphic>
                    <Text>New rights</Text>
                </Item>
            </List>
        {/if}
    </div>
    <div class="col-md-9">
        {#if !selectedRights }
            Nothing is selected
        {:else}
            {#key selectedRights}
            <RoleEditor role={deep_copy(selectedRights)}/>
            {/key}
        {/if}
    </div>

</div>